import {
  NodeViewContent,
  type NodeViewProps,
  NodeViewWrapper,
} from '@tiptap/react'
import type { CSSProperties, JSX } from 'react'
import { columnBlockVariants } from '#src/components/rich-text-editor/column/columnVariants.ts'

interface ColumnBlockAttributes {
  layout: string
  columnWidths: number[] | null
}

export function ColumnBlockView({ node }: NodeViewProps): JSX.Element {
  const attrs = node.attrs as ColumnBlockAttributes
  const rawCount = node.childCount
  const columnCount = Math.max(2, Math.min(4, rawCount)) as 2 | 3 | 4

  return (
    <NodeViewWrapper
      as="div"
      className={columnBlockVariants({ columnCount })}
      data-layout={attrs.layout}
      style={
        {
          '--column-block-contents': 'contents',
        } as CSSProperties
      }
    >
      <style>
        {`
          [data-layout] > [data-node-view-content],
          [data-layout] > [data-node-view-content] > [data-node-view-content-react] {
            display: contents;
          }
        `}
      </style>
      <NodeViewContent />
    </NodeViewWrapper>
  )
}
